/**
 * Client-side Grafiche catalog for admin (/car-part-groups) until API exists.
 * Syncs with VehicleEntry infocar accordion via localStorage + window event.
 */
import {
  DEFAULT_GRAFICHE_CATEGORIES,
  buildMockTitlesForCategory,
} from "@/data/infocarGraficheCategories.js";

export const GRAFICHE_CATALOG_STORAGE_KEY = "leko_grafiche_catalog_v1";
export const GRAFICHE_CATALOG_UPDATED_EVENT = "grafiche-catalog-updated";

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/** @returns {{ categories: object[], linesByCategory: Record<string, object[]> }} */
export function getDefaultGraficheCatalog() {
  const categories = deepClone(DEFAULT_GRAFICHE_CATEGORIES);
  const linesByCategory = {};
  for (const c of categories) {
    linesByCategory[c.categoryCode] = buildMockTitlesForCategory(
      c.categoryCode,
    ).map((row) => ({
      _id: row._id,
      partCode: row.partCode,
      title:
        typeof row.title === "object"
          ? { ...row.title }
          : { it: "", en: "", sq: "" },
    }));
  }
  return { categories, linesByCategory };
}

/** @returns {boolean} */
export function hasStoredGraficheCatalog() {
  try {
    const raw = localStorage.getItem(GRAFICHE_CATALOG_STORAGE_KEY);
    if (!raw) return false;
    const data = JSON.parse(raw);
    return (
      Array.isArray(data.categories) &&
      data.linesByCategory &&
      typeof data.linesByCategory === "object"
    );
  } catch {
    return false;
  }
}

/** @returns {{ categories: object[], linesByCategory: Record<string, object[]> }} */
export function loadGraficheCatalog() {
  if (hasStoredGraficheCatalog()) {
    try {
      const data = JSON.parse(
        localStorage.getItem(GRAFICHE_CATALOG_STORAGE_KEY),
      );
      return {
        categories: data.categories || [],
        linesByCategory: data.linesByCategory || {},
      };
    } catch {
      /* fallthrough */
    }
  }
  return getDefaultGraficheCatalog();
}

/** @param {{ categories: object[], linesByCategory: Record<string, object[]> }} snapshot */
export function saveGraficheCatalog(snapshot) {
  const payload = {
    categories: snapshot.categories || [],
    linesByCategory: snapshot.linesByCategory || {},
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(GRAFICHE_CATALOG_STORAGE_KEY, JSON.stringify(payload));
  window.dispatchEvent(
    new CustomEvent(GRAFICHE_CATALOG_UPDATED_EVENT, { detail: payload }),
  );
}

export function mergeLinesWithVehicleDefaults(rows) {
  return (rows || []).map((r) => ({
    ...deepClone(r),
    selected: typeof r.selected === "boolean" ? r.selected : true,
    notes: r.notes != null ? r.notes : "",
  }));
}
